import { Card, Row, Col } from "react-bootstrap";
import { useClientSummaryData } from "../hooks/ClientSummaryContext";
import Skeleton from "react-loading-skeleton";
import { useClientContext } from "../../../hooks/ClientContext";
import useOpenMasterAccount from "../../../hooks/useOpenMasterAccount";

function NotesSummaryDetails() {
    const { clientSummaryData, clientSummaryError, clientSummaryIsLoading } = useClientSummaryData();
    const { id: masterAccountId } = useClientContext();
    const openMasterAccount = useOpenMasterAccount();

    if (clientSummaryIsLoading) return (
        <Skeleton height={200} />
    )

    if (clientSummaryError) return <p>Error loading data</p>;
    if (!clientSummaryData) {
        return null;
    }

    const handleOpenClientDetails = (e) => {
        e.preventDefault();
        openMasterAccount(masterAccountId, { suffix: "details" });
    };

    return (
        <>
            <Col>
                {clientSummaryData.notes && clientSummaryData.notes.length > 0 && (
                    <div>
                        <Card style={{ height: "auto" }}>
                            <Card.Body>
                                <Card.Title style={{ fontSize: "22px", paddingBottom: "20px" }}><a className="text-reset text-decoration-none" href={`/client/${masterAccountId}/details`}
                                    onClick={(e) => handleOpenClientDetails(e)}>Notes</a>
                                </Card.Title>
                                <Card.Text>
                                    <p>{clientSummaryData.notes}</p>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </div>
                )}
            </Col>
        </>
    )
}

export default NotesSummaryDetails;